module.exports = __webpack_public_path__ + "media/assets/community/mb-badge-static-cabd44581977d4ea6b872c95748570fb19d3d25706dbb7da40c7b87e96925dcc.png";